export default __webpack_public_path__ + "static/media/Jera_Sealed_Fermentation.cdfdfe61.jpg";